<template>
  <div>
    <v-btn
      small
      outlined
      style="text-transform: none; font-size: 12px;"
      :loading="isLoading"
      @click.prevent="showDialog = true"
    >
      Закрыть смену
    </v-btn>
    <primary-confirm-dialog
      v-model="showDialog"
      title="Вы действительно хотите закрыть смену?"
      :loading="isLoading"
      @confirm="closeFiscalShift"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import fiscalShiftApi from '@/api/administrator/fiscal-shift'
  import { autoSettlementNotice } from '@/services/terminal-settlement'
  import permissions from '@/mixins/permissions'
  import snackbarMessage from '@/mixins/snackbar-message'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'

  export default {
    name: 'CloseShiftAction',
    components: { PrimaryConfirmDialog },
    mixins: [permissions, snackbarMessage],
    data () {
      return {
        isLoading: false,
        showDialog: false,
      }
    },
    computed: {
      ...mapGetters({
        localStorageBranch: 'branches/getLocalStorageBranch',
      }),
    },
    methods: {
      async closeFiscalShift () {
        if (!this.userCan(CRMPermission.WorkShift)) {
          this.showErrorMessage('Доступ запрещен')
          return
        }

        this.isLoading = true
        try {
          const response = await fiscalShiftApi.close(this.localStorageBranch.id)
          const notice = autoSettlementNotice(response)

          if (!notice) {
            this.showSuccessMessage('Смена успешно закрыта')
          } else if (notice.isError) {
            this.showErrorMessage(notice.text)
          } else {
            this.showSuccessMessage(`Смена закрывается. ${notice.text}`)
          }
          this.showDialog = false
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
